import api from "@/api/v1-jwt/config/api";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import notificationQueryKeys from "./query-keys";
import { NotificationInfo, AddNotificationPayload } from "./types";

interface DeleteNotificationParams {
  userId: string;
  notificationSubject: string;
  payload: AddNotificationPayload;
}

const deleteNotification = async ({
  userId,
  notificationSubject,
  payload,
}: DeleteNotificationParams): Promise<NotificationInfo> => {
  const url = `/platform/notifications/${userId}/info`;
  const requestBody = {
    notification_subject: notificationSubject.toUpperCase(),
    notification_info: {
      notification_info: [payload],
    },
  };
  const { data } = await api.delete(url, { data: requestBody });
  return data.data;
};

export const useDeleteNotification = (
  options?: Omit<
    UseMutationOptions<NotificationInfo, Error, DeleteNotificationParams>,
    "mutationFn"
  >
) => {
  const queryClient = useQueryClient();

  return useMutation<NotificationInfo, Error, DeleteNotificationParams>({
    ...options,
    mutationFn: deleteNotification,
    onSuccess: (...d) => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.all,
      });
      if (options?.onSuccess) {
        options?.onSuccess(...d);
      }
    },
  });
};
